import React from 'react';

const CompanyProfile = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm p-6">
      <h2 className="text-xl font-semibold text-slate-200 mb-6">Company Profile</h2>
      <p className="text-slate-400">Company Profile data will be displayed here.</p>
    </div>
  );
};

export default CompanyProfile;
